export const headerName = {
  add: "Добавить категорию",
  edit: "Редактировать категорию",
};
export const swimmingDifficultyCategoryData = {
  sacName: {
    key: "sacName",
    label: "Наименование категории",
    type: "text",
    required: true,
  },
  sacNote: {
    key: "sacNote",
    label: "Примечание",
    type: "text",
    required: true,
  },
};

export const getSwimmingDifficultyCategoryDataModal = () =>
  swimmingDifficultyCategoryData;
